import React from 'react';
import './ConversationItemAnimation.css';

/**
 * ConversationItemAnimation
 * Skeleton loading animation for conversation details view
 * Shows a shimmer effect while the conversation data is loading
 */
const ConversationItemAnimation: React.FC = () =>
{
  return (
    <div>
      <div className="item-detail-timeline-wrapper">
        <div className="item-detail-timeline-item">
          <div className="item-detail-animated-background">
            <div className="item-detail-background-masker card-bar one"></div>
            <div className="item-detail-background-masker card-header layer"></div>
            <div className="item-detail-background-masker card-header item"></div>
            <div className="item-detail-background-masker card-header check"></div>
            <div className="item-detail-background-masker card-header space"></div>
            <div className="item-detail-background-masker card-header project"></div>
            <div className="item-detail-background-masker card-header project bottom"></div>
            <div className="item-detail-background-masker card-header action"></div>
            <div className="item-detail-background-masker card-header action dots"></div>
            <div className="item-detail-background-masker card-header action right"></div>
            <div className="item-detail-background-masker card-bar two"></div>
            <div className="item-detail-background-masker card-title left"></div>
            <div className="item-detail-background-masker card-title right"></div>
            <div className="item-detail-background-masker card-bar three"></div>
            <div className="item-detail-background-masker card-title bottom left"></div>
            <div className="item-detail-background-masker card-title bottom right"></div>
            <div className="item-detail-background-masker card-bar four"></div>
            <div className="item-detail-background-masker card-description left"></div>
            <div className="item-detail-background-masker card-description right"></div>
            <div className="item-detail-background-masker card-bar five"></div>
            <div className="item-detail-background-masker card-description bottom left"></div>
            <div className="item-detail-background-masker card-description bottom right"></div>
            <div className="item-detail-background-masker card-bar six"></div>
            <div className="item-detail-background-masker card-reply left"></div>
            <div className="item-detail-background-masker card-reply center"></div>
            <div className="item-detail-background-masker card-reply right"></div>
            <div className="item-detail-background-masker card-bar seven"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversationItemAnimation;
